import {email, required} from '../units';
import validate from '../common';

const getValidations = fields => {
  const validations = {};

  fields.forEach(fieldName => {
    const validators = [];

    switch (fieldName) {
      case 'email':
        validators.push(required(), email());
        break;

      case 'promo_email_agreement':
        break;

      default:
        validators.push(required());
        break;
    }

    validations[fieldName] = validators;
  });

  return validations;
};

export default fields => ({
  validate: validate(getValidations(fields))
});



// WEBPACK FOOTER //
// ./validators/forms/ask.js